import React from 'react';
import { Table } from 'antd';
import { isOnMobile } from '../../lib/Utils';

interface AdminTableProps {
  dataSource: object[];
  columns: object[];
  loading: boolean;
}

export const AdminTable = ({
  dataSource,
  columns,
  loading,
}: AdminTableProps) => (
  <div className="admin-table-container">
    <Table
      dataSource={dataSource}
      columns={columns}
      loading={loading}
      pagination={false}
      scroll={{
        x: isOnMobile() ? 800 : null,
        y: isOnMobile() ? 'calc(60vh)' : null,
      }}
      id="admin-table"
    />
  </div>
);
